class PathSynchroSetupDto {
    AdditionActivated: boolean;
    UpdateActivated: boolean;
    DeletionActivated: boolean;

    constructor(additionActivated: boolean, updateActivated: boolean, deletionActivated: boolean) {
        this.AdditionActivated = additionActivated;
        this.UpdateActivated = updateActivated;
        this.DeletionActivated = deletionActivated;
    }
}

export default PathSynchroSetupDto;